export const url_CarregarDados_ID = '/prontuario/carregar/:idprontuario/:id_clinica';

